export const TEST_IDS = {
	trigger: 'qa-user-profile-trigger',
	content: 'qa-user-profile-content'
};
